<template>
  <div class="modal fade custom-modal" id="editBuildingModal" tabindex="-1" role="dialog" aria-hidden="true" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content custom-modal-content">
        <div class="dismiss-modal-btn" data-dismiss="modal" aria-label="Close">
          <i class="fad fa-times-circle"></i>
        </div>
        <div class="modal-header custom-modal-header">
          <i class="fad fa-building"></i>
          <h5 class="modal-title"> Editeaza Bloc </h5>
        </div>
        <div class="modal-body custom-modal-body" v-if="building">
          <form id="form-add-block">
            <input type="hidden" name="type" value="building" />
            <div class="input-container">
              <div class="flex-row align-items-end input-group mg-b">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-addon1">Bloc</span>
                </div>
                <input type="text" id="block-name" name="name" v-model="building.name" placeholder="* Denumire bloc">
                <label class="custom-label" for="block-name"> * Denumire bloc </label>
              </div>
              <p class="custom-input-error" id="name_error"></p>
            </div>
            <div class="input-container">
              <div class="input-group mg-b">
                <select name="finalized_year" id="finalized_year" v-model="building.finalized_year" placeholder="* An finalizare">
                  <option v-for="year in finalizedYear" :value="year.value" :key="year.value"> {{year.name}} </option>
                </select>
                <select name="finalized_month" id="finalized_month" v-model="building.finalized_month" placeholder="* Luna finalizare">
                  <option v-for="month in finalizedMonth" :value="month.value" :key="month.value"> {{month.name}} </option>
                </select>
                <div class="input-icon">
                  <i class="fad fa-calendar-day"></i>
                </div>
                <label class="custom-label" for="finalized_month"> * Luna finalizare </label>
                <label class="custom-label" for="finalized_year"> * An finalizare </label>
              </div>
              <p class="custom-input-error" id="finalized_month_error"></p>
              <p class="custom-input-error" id="finalized_year_error"></p>
            </div>
            <div class="secondary-heading">
              <div class="secondary-heading-icon">
                <i class="fad fa-layer-group"></i>
              </div>
              <span> Alege etaje </span>
            </div>
            <ul class="checkboxes-list">
              <li v-for="(level, key) in definedLevels" :key="key" class="text-placeholder-radio">
                <input type="checkbox" :id="'floor-' + level.id" class="text-checkbox-input"
                       v-model="levels"
                       :value="level"
                       @change="updateCheckAll()">
                <label :for="'floor-' + level.id" class="radio-input-placeholder">
                  <span> {{level.name}} </span>
                </label>
              </li>
            </ul>
            <p class="custom-input-error" id="levels_error"></p>
            <p class="custom-input-error" :id="`levels-${index}_error`" v-for="(lvl, index) in levels" :key="`lvl-${index}`"></p>
            <div class="general-check">
              <input type="checkbox" id="select-all-checkboxes"
                     class="custom-checkbox" @click="checkAll" v-model="isCheckAll">
              <label for="select-all-checkboxes" class="custom-checkbox-label">
                <span></span>
                <p>
                  Selecteaza toate etajele
                </p>
              </label>
            </div>
          </form>
        </div>
        <div class="modal-footer custom-modal-footer">
          <button type="button" class="general-btn negative-btn" @click="dismissModal()">
            <i class="fad fa-times-circle"></i>
            <span> Inchide </span>
          </button>
          <button type="submit" class="general-btn positive-btn" @click="save()">
            <i class="fad fa-save"></i>
            <span> Salveaza </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DeveloperEditBuilding",
    components: {},
    data() {
      return {
        building: null,
        type: null,
        definedLevels: [],
        levels: [],
        isCheckAll: false,
        finalizedMonth: [
          { value: 1, name: "Ianuarie"}
          ,{ value: 2, name: "Februarie"}
          ,{ value: 3, name: "Martie"}
          ,{ value: 4, name: "Aprilie"}
          ,{ value: 5, name: "Mai"}
          ,{ value: 6, name: "Iunie"}
          ,{ value: 7, name: "Iulie"}
          ,{ value: 8, name: "August"}
          ,{ value: 9, name: "Septembrie"}
          ,{ value: 10, name: "Octombrie"}
          ,{ value: 11, name: "Noiembrie"}
          ,{ value: 12, name: "Decembrie"}
        ],
        finalizedYear: []
      }
    },
    async created() {
      await this.getLevels()
      let startYear = 2015;
      let endYear = new Date().getFullYear() + 5;
      let year;
      for (year = startYear;year <= endYear; year++) {
        this.finalizedYear.push({ value: year, name: year});
      }
    },
    watch: {
      // called when building variable is changed
      building: function(){
        this.levels = []
        this.type = null
        if(this.building) {
          this.setSelectedLevels()
        }
        this.updateCheckAll()
      }
    },
    computed: {

    },
    async mounted() {
      let vm = this
      // on close modal
      $('#editBuildingModal').on('hidden.bs.modal', function () {
        vm.building = null
        vm.type = null
      });

      // on open modal
      this.$eventBus.$on('OPEN_EDIT_BUILDING_MODAL',async function (payLoad) {
        vm.type = payLoad.type
        await vm.getModelData(payLoad.buildingId)
        $('#editBuildingModal').modal('show')
      });
    },
    methods: {
      async getModelData(buildingId) {
        let vm = this
        vm.triggerLoader(true)
        await window.axios.get(`/ajax/developer/get-building/${buildingId}`)
            .then(function (resp) {
              vm.triggerLoader(false)
              vm.building = resp.data.data
            })
            .catch(function (err) {
              vm.triggerLoader(false)
              window.showError(err)
            });
      },
      async getLevels() {
        let vm = this;
        await window.axios.get(`/get-levels`)
            .then(function (response) {
              vm.definedLevels = response.data.data;
            })
            .catch(function (err) {
              window.showError(err)
            });
      },
      setSelectedLevels(){
        this.levels = []
        for(let i in this.building.levels) {
          if(this.definedLevels.find(l => parseInt(l.id) === parseInt(this.building.levels[i].id))){
            this.levels.push(this.definedLevels.find(l => parseInt(l.id) === parseInt(this.building.levels[i].id)))
          }
        }
      },
      checkAll: function () {
        this.isCheckAll = !this.isCheckAll;
        this.levels = [];

        if (this.isCheckAll) {
          for (let level in this.definedLevels) {
            this.levels.push(this.definedLevels[level]);
          }
        }
      },
      updateCheckAll: function () {
        this.isCheckAll = this.levels.length === this.definedLevels;
      },
      dismissModal() {
        $('#editBuildingModal').modal('hide')
      },
      save() {
        window.resetErrors()
        let vm = this;
        let myForm = document.getElementById('form-add-block');
        let lvl = [];
        for (let index = 0; index < this.levels.length; index++) {
          lvl.push(this.levels[index].id);
        }
        let formData = new FormData(myForm);
        formData.append('building_id', this.building.id);
        formData.append('levels', JSON.stringify(lvl));
        window.axios.post(`/developer/building/edit`,formData)
            .then(function () {
              window.Swal.fire({
                html: 'Blocul a fost modificat cu succes',
                icon: 'success',
                timer: 2000,
                showCancelButton: false,
                showConfirmButton: false
              }).then(() => {
                if (vm.type === 'commercial') {
                  window.location.href = `/developer/project/${vm.building.project_id}?tab=space-buildings`
                } else {
                  window.location.href = `/developer/project/${vm.building.project_id}?tab=apartment-buildings`
                }
              })
            })
            .catch(function (err) {
              window.showError(err)
            });
      }
    }
  }
</script>
